module.exports = __webpack_public_path__ + "img/jwi.fca82749.png";